export default "__VITE_ASSET__ca8478df__"